export const clamp = (
  value: number,
  min: number,
  max: number,
  decimals: number
) => {
  const bounded = Math.min(max, Math.max(min, value));
  const factor = 10 ** decimals;

  return Math.round(bounded * factor) / factor;
};
